import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SelectBatches from './SelectBatches/index';
import AccountListManagement from './AccountList';
import { getBranchList } from '../../actions/commonAction';
import { getBatchNumber, getPatternIdType, getWarehouseTotalSlots } from '../../actions/saActions'
import { getUserPreference } from '../../utilities/common';
import { setSelectedBatchIdsSlot } from '../../reducers/uiSlice';
import UserAuth from './UserAuth'
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme)=> ({
    boxContainer: {
        padding: 20,
        backgroundColor: "#424242", 
        display: "flex",
        justifyContent: "space-between",
    },
    leftPanel: {
        width:'44%',
        marginRight: 10,
        border: 'solid 1px rgba(255, 255, 255, 0.5)',
        borderRadius: 10,
        padding: 20
    },
    rightPanel: {
        overflowY:'auto',
        overflowX:'hidden',
        width:'44%',
        height: '100vh',
        border: 'solid 1px rgba(255, 255, 255, 0.5)',
        borderRadius: 10,
        padding: 20
    }
}))

export default function SlotAssignment() {
    const classes = useStyles();
    const dispatch = useDispatch();

    let userPref = getUserPreference();

    const [branches, setBranches] = useState([]);
    const [branch, setBranch] = useState(userPref.userCity);
    const [ifHidden, setIfHidden] = useState(true);

    useEffect(() => {
        setIfHidden(true);
        if(branches) {
            dispatch(getBranchList()).then((branches)=>{
                setBranches(branches);
            })           
        }
        dispatch(getPatternIdType())
    }, [])

    useEffect(() => {
        dispatch(getBatchNumber(branch));
        dispatch(setSelectedBatchIdsSlot());
        dispatch(getWarehouseTotalSlots(branch));    
    }, [branch])

    return (
        <Box style={{backgroundColor: "#424242", height: '100vh'}}>
            <Box className={classes.boxContainer}>
                <div className={classes.leftPanel}>
                    <SelectBatches branches={branches} handleWarehouseChange={handleWarehouseChange}/>
                </div>               
                <div className={classes.rightPanel}>
                    <div>
                        <AccountListManagement branch={branch}/>
                    </div>            
                </div>
            </Box>
        </Box>       
    );

    function handleWarehouseChange(warehouse) {
        setBranch(warehouse);
    }

    function setHidden(ifHidden) {
        setIfHidden(ifHidden);
    }
}